import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type {
  ShareCreatePayload,
  ShareDeletePayload,
  ShareItem,
  ShareInfo,
  ApiSuccessResponse,
  ServiceResponse,
} from '@dopomogai/types';

export const shareService = {
  createShare: (payload: ShareCreatePayload): ServiceResponse<ShareInfo> => {
    return getApiClient()
      .post<ShareInfo>('/shares', payload)
      .then(response => response.data)
      .catch(err => handleApiError(err, 'creating share'));
  },

  listSharesForMe: (): ServiceResponse<ShareItem[]> => {
    return getApiClient()
      .get<ShareItem[]>('/shares/my')
      .then(response => response.data)
      .catch(err => handleApiError(err, 'listing shared resources'));
  },

  listOwnedShares: (): ServiceResponse<ShareInfo[]> => {
    return getApiClient()
      .get<ShareInfo[]>('/shares/owned')
      .then(response => response.data)
      .catch(err => handleApiError(err, 'listing owned shares'));
  },

  deleteShare: (payload: ShareDeletePayload): ServiceResponse<ApiSuccessResponse> => {
    return getApiClient()
      .delete('/shares', { data: payload })
      .then(response => response.data as ApiSuccessResponse)
      .catch(err => handleApiError(err, 'deleting share'));
  },
};